import React from 'react';

export const name = 'flag-AT';

export const FlagAT = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_26)">
      <mask
        id="mask0_2_26"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_26)">
        <path
          d="M23.25 16.1719C24.2506 13.4806 24.2506 10.5194 23.25 7.82812L12 6.78281L0.750006 7.82812C-0.250124 10.5194 -0.250124 13.4805 0.750006 16.1719L12 17.2172L23.25 16.1719Z"
          fill="#EEEEEE"
        />
        <path
          d="M12 24C14.4501 23.9997 16.8414 23.2494 18.8525 21.85C20.8636 20.4506 22.3982 18.4691 23.25 16.1719H0.75C1.60179 18.4691 3.13636 20.4506 5.14748 21.85C7.15861 23.2494 9.54989 23.9997 12 24ZM12 0C9.54989 0.000299071 7.15861 0.750567 5.14748 2.14997C3.13636 3.54938 1.60179 5.53088 0.75 7.82812H23.25C22.3982 5.53088 20.8636 3.54938 18.8525 2.14997C16.8414 0.750567 14.4501 0.000299071 12 0Z"
          fill="#D80027"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_26">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
